import {
    Archive,
    LayoutGrid,
    Mic,
    MoreHorizontal,
    Search,
    Settings,
    type LucideIcon,
} from 'lucide-react';
import { ROUTES } from '../../lib/routes';

export interface NavigationItem {
    to?: string;
    label: string;
    icon: LucideIcon;
    exact?: boolean;
    mobilePrimary?: boolean;
    moreOnly?: boolean;
}

export interface NavigationGroup {
    title: string;
    items: NavigationItem[];
}

export function isActivePath(pathname: string, to: string, exact = false): boolean {
    if (exact) return pathname === to;
    return pathname === to || pathname.startsWith(`${to}/`);
}

export function getNavigationGroups(t: (key: string) => string): NavigationGroup[] {
    return [
        {
            title: t('sections.main'),
            items: [
                {
                    to: ROUTES.HOME,
                    label: t('items.capture'),
                    icon: Mic,
                    mobilePrimary: true,
                },
                {
                    to: ROUTES.SEARCH,
                    label: t('items.search'),
                    icon: Search,
                    mobilePrimary: true,
                },
                {
                    to: ROUTES.CATEGORIES,
                    label: t('items.categories'),
                    icon: LayoutGrid,
                    mobilePrimary: true,
                },
                {
                    to: ROUTES.BIN,
                    label: t('items.bin'),
                    icon: Archive,
                    mobilePrimary: true,
                },
            ],
        },
        {
            title: t('sections.settings'),
            items: [
                {
                    to: ROUTES.MORE,
                    label: t('items.settings'),
                    icon: Settings,
                    exact: true,
                    moreOnly: true,
                },
            ],
        },
    ];
}

export function getMobilePrimaryItems(groups: NavigationGroup[]): NavigationItem[] {
    const mobileOrder = [
        ROUTES.BIN,
        ROUTES.SEARCH,
        ROUTES.HOME,
        ROUTES.CATEGORIES,
    ];
    const itemsByRoute = new Map(
        groups
            .flatMap((group) => group.items)
            .filter((item) => item.mobilePrimary && item.to)
            .map((item) => [item.to, item])
    );

    return mobileOrder.flatMap((route) => {
        const item = itemsByRoute.get(route);
        return item ? [item] : [];
    });
}

export const moreNavigationItem = {
    label: 'More',
    icon: MoreHorizontal,
} as const;
